// extracted by mini-css-extract-plugin
module.exports = {"reason-input":"newAccountsList_reason-input__3ZSAr","new-accounts-table":"newAccountsList_new-accounts-table__1Ox1d"};